function ReplenishmentIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6_1040)">
        <path
          d="M12 7.45333V6.66667H13.3333V7.35333C13.2267 7.33333 13.1133 7.33333 13 7.33333C12.6667 7.33333 12.3333 7.38 12 7.45333ZM10 7.66667C10 7.48 9.85333 7.33333 9.66667 7.33333H6.33333C6.14667 7.33333 6 7.48 6 7.66667V8.66667H9.88L10 8.54667V7.66667ZM4 12.6667V6.66667H2.66667V14H9.35333C9.09333 13.5933 8.9 13.1467 8.78667 12.6667H4ZM14 6H2V2H14V6ZM12.6667 3.33333H3.33333V4.66667H12.6667V3.33333ZM12.6667 9V8L11.1667 9.5L12.6667 11V10C13.1087 10 13.5326 10.1756 13.8452 10.4882C14.1577 10.8007 14.3333 11.2246 14.3333 11.6667C14.3333 11.9333 14.2733 12.1867 14.16 12.4133L14.8867 13.14C15.1667 12.72 15.3333 12.2133 15.3333 11.6667C15.3333 10.1933 14.14 9 12.6667 9ZM12.6667 13.3333C12.2246 13.3333 11.8007 13.1577 11.4882 12.8452C11.1756 12.5326 11 12.1087 11 11.6667C11 11.4 11.06 11.1467 11.1733 10.92L10.4467 10.1933C10.1667 10.6133 10 11.12 10 11.6667C10 13.14 11.1933 14.3333 12.6667 14.3333V15.3333L14.1667 13.8333L12.6667 12.3333V13.3333Z"
          fill={!isActive ? '#828282' : '#FFFFFF'}
        />
      </g>
      <defs>
        <clipPath id="clip0_6_1040">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ReplenishmentIcon
